import React, {useContext, useState, SyntheticEvent } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {TextdomainContext} from 'react-gettext';

import ntnuLogo from "../images/NTNU_bareLogo.png";
import UiBLogo from "../images/UiB.png";
import UiOLogo from "../images/UiOLogo.png";
import UiTLogo from "../images/UiT.png";
import {Alert} from "@mui/material";

const Employees: React.FC = () => {

  const {gettext} = useContext(TextdomainContext);
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  return (
    <div>
      <Container maxWidth="md">
        <Alert severity="info">
          <Typography
            variant="h6">{gettext('Oversikt over og kontaktmåter for FVO baser driftet ved MH')}</Typography>
          <Typography variant="body2">{gettext('Generell hjelp alle baser finnes')} <a
            href="https://dmf.fogbugz.com/default.asp?W197">{gettext('HER')}!</a><br/>
            {gettext('Noen baser har egne hjelpesider i tillegg, se under')}.<br/>
            {gettext('Klikk på overskriftene under for å se informasjon om hver base')}.</Typography>
        </Alert>
      </Container>
      <br/>
      <Container maxWidth="md">
        <Accordion
          expanded={expanded === 'ntnu'}
          onChange={handleChange('ntnu')}
            >
          <AccordionSummary
            id="ntnu-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography variant="body1">
              <img src={ntnuLogo} height="50px" alt="NTNU logo"/>
              {' '}
              NTNU MH {gettext('Profesjonsstudiet i medisin')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              {`${gettext('Denne basen har bare oppgaver beregnet for profesjonsstudiet i medisin ved MH fakultetet ved NTNU')}.
${gettext('Klikk på lenken under for å gå til basen')}.
${gettext('Du må undervise eller ha en administrativ rolle på medisinstudiet ved')} NTNU ${gettext('for å få tilgang')}`}.
              <br/>
              <br/>
              <a
                href="https://mcq.medisin.ntnu.no/mcq/">https://mcq.medisin.ntnu.no/mcq/</a>
              <br/>
            </Typography>
              <Typography variant="h5">Nytt brukergrensesnitt!</Typography>
              <Typography variant="body2">
                Nytt brukergrensesnitt er på vei. Du kan teste det her:
                <a
                    href="https://mcq.medisin.ntnu.no/mcqadmin">https://mcq.medisin.ntnu.no/mcqadmin</a>
                <br/>
              </Typography>
              <br/>
            <Typography>
              {gettext('Får du beskjed om manglende tilgang men mener at dette er feil så kan du registrere en jobb ved')}
              <br/>
              <a href="https://hjelp.ntnu.no">hjelp.ntnu.no</a>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'mh'}
          onChange={handleChange('mh')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="mh"
          >
            <Typography variant="body1">
              <img src={ntnuLogo} height="50px" alt={"NTNU logo"}/>
              {' '}
              NTNU MH {gettext('Audiologi og bevegelse')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              {`${gettext('Denne basen oppgaver beregnet for emner UTENOM medisinstudiet ved MH fakultetet ved NTNU')}.
                            ${gettext('Basen er i prøvedrift for utvalgte emner på INB.')}
${gettext('Klikk på lenken under for å gå til basen')}.
${gettext('Du må være emneansvarlig eller ha en administrativ rolle for å få tilgang')}`}.
              <br/>
              <br/>
              <a href="https://mcq.medisin.ntnu.no/mh/">https://mcq.medisin.ntnu.no/mh/</a>
              <br/>
            </Typography>
              <Typography variant="h5">Nytt brukergrensesnitt!</Typography>
              <Typography variant="body2">
                Nytt brukergrensesnitt er på vei. Du kan teste det her:
                <a
                    href="https://mcq.medisin.ntnu.no/mcqadmin_mh">https://mcq.medisin.ntnu.no/mcqadmin_mh</a>
                <br/>

              <br/>
              {gettext('Får du beskjed om manglende tilgang men mener at dette er feil så kan du registrere en jobb ved')}
              <br/>
              <a href="https://hjelp.ntnu.no">hjelp.ntnu.no</a>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'uib'}
          onChange={handleChange('uib')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="uib"
          >
            <Typography variant="body1">
              <img src={UiBLogo} height="50px" alt="UiB logo"/>
              {gettext('UiB Det medisinske fakultet - Profesjonsstudiet i medisin')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              {`${gettext('Denne basen har bare oppgaver beregnet for profesjonsstudiet i medisin ved det Medisinske fakultet ')} UiB.
${gettext('Klikk på lenken under for å gå til basen')}.
${gettext('Faste, vitenskapelige ansatte har automatisk tilgang. Stipendiater, postdoktorer og administrative gis tilgang på forespørsel til kontaktadressen nedenfor')}`}.
              <br/>
              <br/>
              <a
                href="https://mcq.medisin.ntnu.no/uib/">https://mcq.medisin.ntnu.no/uib/</a>
              <br/>
            </Typography>
              <Typography variant="h5">Nytt brukergrensesnitt!</Typography>
              <Typography variant="body2">
                Nytt brukergrensesnitt er på vei. Du kan teste det her:
                <a
                    href="https://mcq.medisin.ntnu.no/mcqadmin_uib/">https://mcq.medisin.ntnu.no/mcqadmin_uib/</a>
                <br/>
              <br/>
              {gettext('Får du beskjed om manglende tilgang men mener at dette er feil så kan du ta kontakt med')}:<br/>
              <a href="mailto:eirik.dalheim@uib.no">Eirik Dalheim, eirik.dalheim@uib.no</a>
              <br/>
              {gettext('UiB har laget egne hjelpesider i tillegg til den generelle hjelpen')}:<br/>
              <a
                href="http://www.uib.no/med/111615/database-flervalgsoppgaver-fvo-i-medisinstudiet ">{gettext('Egne hjelpesider for UiB')}</a>
              <br/>
              {gettext('Finner du ikke svar på dine problemer der så fungerer Eirik Dalheim som førstelinje for å få hjelp')}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'uio'}
          onChange={handleChange('uio')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="uio"
          >
            <Typography variant="body1">
              <img src={UiOLogo} height="50px" alt="UiO logo"/>
              {gettext('UiO Det medisinske fakultet - Profesjonsstudiet i medisin')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              {`${gettext('Denne basen har bare oppgaver beregnet for profesjonsstudiet i medisin ved det medisinske fakultet ved')} UiO.
${gettext('Klikk på lenken under for å gå til basen')}.
${gettext('Du må undervise eller ha en administrativ rolle på medisinstudiet ved')} UiO ${gettext('for å få tilgang')}`}.
            </Typography>
            <Typography variant="body2">
              <a
                href="https://mcq.medisin.ntnu.no/uio/">https://mcq.medisin.ntnu.no/uio/</a>
              <br/>
            </Typography>
              <Typography variant="h5">Nytt brukergrensesnitt!</Typography>
              <Typography variant="body2">
                Nytt brukergrensesnitt er på vei. Du kan teste det her:
                <a
                    href="https://mcq.medisin.ntnu.no/mcqadmin_uio">https://mcq.medisin.ntnu.no/mcqadmin_uio</a>
                <br/>
              <br />
              {gettext('Får du beskjed om manglende tilgang men mener at dette er feil så kan du ta kontakt med')}:<br/>
              <a href="mailto:asmund.skaar@medisin.uio.no">Åsmund Skaar,
                asmund.skaar@medisin.uio.no</a>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'uit'}
          onChange={handleChange('uit')}
        >
          <AccordionSummary
            id="uit"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography variant="body1">
              <img src={UiTLogo} height="50px" alt="Uit logo"/>
              {gettext('UiT Det helsevitenskapelige fakultet - Profesjonsstudiet i medisin')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              {`${gettext('Denne basen har bare oppgaver beregnet for profesjonsstudiet i medisin ved det helsevitenskapelige fakultet ved UiT')}.
${gettext('Klikk på lenken under for å gå til basen')}.
${gettext('Du må undervise eller ha en administrativ rolle på medisinstudiet ved')} UiT ${gettext('for å få tilgang')}`}.
            </Typography>
            <br/>
            <br/>
            <Typography
                variant="body2"
            ><a href="https://mcq.medisin.ntnu.no/uit/">https://mcq.medisin.ntnu.no/uit/</a>
            </Typography>
            <br/>
            <Typography variant="h5">Nytt brukergrensesnitt!</Typography>
            <Typography variant="body2">
              Nytt brukergrensesnitt er på vei. Du kan teste det her:
              <a
                  href="https://mcq.medisin.ntnu.no/mcqadmin_uit">https://mcq.medisin.ntnu.no/mcqadmin_uit</a>
              <br/>
            </Typography>
            <br/>
            <Typography variant="body2">
              {gettext('Får du beskjed om manglende tilgang men mener at dette er feil så kan du ta kontakt med')}:<br/>
              Elin Holm, elin.holm@uit.no
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'nasjonal'}
          onChange={handleChange('nasjonal')}
        >
          <AccordionSummary
            id="nasjonal"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography variant={"body1"}>
              <img src={ntnuLogo} height="50px" alt="NTNU logo"/>
              <img src={UiBLogo} height="50px" alt="UiB logo"/>
              <img src={UiOLogo} height="50px" alt="UiO logo"/>
              <img src={UiTLogo} height="50px" alt="UiT logo"/>
              {gettext('Nasjonal delprøve for profesjonsstudiet i medisin')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              {`${gettext('Denne basen har bare oppgaver beregnet for nasjonal delprøve i medisin for alle landets profesjonsstudier i medisin')}.
${gettext('Klikk på ei av lenkene under for å gå til basen')}.
${gettext('Du må være fagfelle, være med i en arbeidsgruppe eller ha en administrativ rolle på ett av medisinstudiene ved')} ett av universitetene ${gettext('for å få tilgang')}`}.
              <br/>
              <br/>
              <a href="https://mcq.medisin.ntnu.no/nasjonal/">
                {gettext('Pålogging for oppgaveforfattere og administratorer')}
              </a>
            </Typography>
              <br/>
              <Typography variant="h5">Nytt brukergrensesnitt!</Typography>
              <Typography variant="body2">
                Nytt brukergrensesnitt er på vei. Du kan teste det her:
                <a
                    href="https://mcq.medisin.ntnu.no/mcqadmin_nasjonal">https://mcq.medisin.ntnu.no/mcqadmin_nasjonal</a>
                <br/>
              </Typography>
              <br/>
            <Typography>
              <a href="https://mcq.medisin.ntnu.no/nasjonal/?authMethod=mh-auth">
                {gettext('Pålogging for fagfeller')}</a>
            </Typography>
            <br/>
            <Typography variant={"body2"}>
              {gettext('Får du beskjed om manglende tilgang men mener at dette er feil så kan du ta kontakt med')}:<br/>
              <a href="mailto:asmund.skaar@medisin.uio.no">Åsmund Skaar,
                asmund.skaar@medisin.uio.no</a>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Container>
    </div>
  );
};

export default Employees;
